import { Vector3 as r } from "three";
const i = (n, o, s = new r(0, 1, 0)) => {
  const t = n.angleTo(o), e = n.clone().cross(o), c = Math.sign(s.dot(e)) || 1;
  return t * c;
};
export {
  i as SignedAngle
};
//# sourceMappingURL=index32.js.map
